import React from 'react';
import ItemBonus from '../../components/itemBonus';
import {useRouter} from '../../../../../@casino/useRouter';
import {setGetListBonuses} from '../../store/thunk/setGetListBonuses';
import { useDispatch, useSelector } from 'react-redux';
import {getLabel} from '../../../../../@casino/lib/getLabel';
import Title from '../../../../../@casino/ui/title';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20,
        paddingTop: 0
    },
    wrap: {
        display: 'flex',
        flexWrap: 'wrap'
    }
}))

const Bonuses = () => {
    const router = useRouter();
    const dispatch = useDispatch();
    const classes = useStyles();

    React.useEffect(() => {
        dispatch(setGetListBonuses());
    }, [])

    const list = useSelector(state => state.bonuses.list);

    return (
        <div className={classes.root}>
            <Title label="Бонусы" />
            <div className={classes.wrap} style={{gap: 20}}>
                {
                    list.map((item) => item.label !== 'bonus-referral' && <ItemBonus name={item.bonus_name} label={getLabel(item.label)} event={() => router.history.push(`/bonuses/settings/${item.label}/${item.id}`)} />) 
                }
                <ItemBonus name="+" event={() => router.history.push('/bonuses/select-template')} />
            </div>
            
          
        </div>
    )
}

export default Bonuses;